<template>
    <v-container grid-list-md>
        <v-card-title>
            <CreateFtnModal :laboratorio_id="id" v-on:update="getFtn"></CreateFtnModal>
        </v-card-title>

        <v-data-table
                :headers="headers"
                :items="amcs.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }} <v-icon left color="error" v-if="props.item.blocked">error</v-icon></td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <EditFtnModal :ftn="props.item" v-on:update="getFtn"></EditFtnModal>
                            </v-list-tile>
                            <v-list-tile>
                                <NotificationsComponent :id="props.item.id" :contact="props.item" v-on:guardar="saveNotifications"></NotificationsComponent>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat v-on:click="sendResetPassword(props.item.email)"><v-icon left>email</v-icon>Restore password</v-btn>
                            </v-list-tile>
                            <v-list-tile v-if="props.item.blocked">
                                <v-btn flat v-on:click="unblock(props.item.id)"><v-icon left>login</v-icon>Unblock</v-btn>
                            </v-list-tile>
                            <!--
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                            -->
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="amcs.data">
            <v-pagination
                    v-model="page"
                    :length="amcs.meta.last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ amcs.meta.from }} to {{ amcs.meta.to }} of {{ amcs.meta.total }} entries</p>
        </div>
    </v-container>
</template>

<script>
    import CreateFtnModal from '../components/CreateFtnModal';
    import EditFtnModal from '../components/EditFtnModal';
    import NotificationsComponent from '../components/NotificationsComponent';

    export default {
        props: ['id'],
        data : function() {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                error : false,
                message_error : null,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: 'Email',
                        align: 'left',
                        sortable: true,
                        value: 'email'
                    },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                amcs: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
            }
        },
        created: function () {
            this.getFtn();
            this.debouncedGetAmcs = _.debounce(this.getFtn, 500)
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetAmcs();
            },
            last_page: function () {
                if (this.page > this.amcs.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            saveNotifications (contact) {
                this.$store.dispatch('updateUserNotifications', contact).then((res) => {
                    this.getFtn();
                }).catch((error) => {

                });
            },
            setPage (page) {
                console.log(page);
                this.page = page;
                this.getFtn();
            },
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getFtn();
            },
            getFtn() {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.id
                    }
                };
                this.$store.dispatch('getLaboratorioFtn', params).then((res) => {
                    this.amcs = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }
                }).catch((error) => {

                });
            },
            deleteItem(ftn_id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        var params = {
                            filters : {
                                laboratorio_id: this.id,
                                ftn_id: ftn_id
                            }
                        };
                        this.$store.dispatch('deleteLaboratorioFtn', params).then((res) => {
                            this.getFtn();
                        }).catch((error) => {

                        });
                    }
                });
            },
            sendResetPassword(email) {
                var params = {
                    filters : {
                        email: email
                    },
                    email: email
                };
                this.$store.dispatch('sendResetPassword', params).then((res) => {
                    this.getFtn();
                }).catch((error) => {

                });
            },
            unblock (id) {
                this.$confirm('Do you really want to unblock the user?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('unblockUser', {
                            id: id
                        }).then((res) => {

                            this.getFtn();

                        }).catch((error) => {

                        });
                    }
                })
            }
        },
        components: {
            CreateFtnModal,
            EditFtnModal,
            NotificationsComponent
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/amcs/view/FtnsComponent.vue